import React, { ButtonHTMLAttributes } from 'react';
import styled from 'styled-components';

const s = {
  Button: styled.button<{ isVisible: boolean }>`
    height: 100%;
    box-sizing: border-box;
    position: relative;
    transition: left 0.2s, width 0.2s;
    left: ${(props) => (props.isVisible ? 0 : -20)}px;
    width: ${(props) => (props.isVisible ? 75 : 0)}px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    border: none;
    outline: none;
  `,
  ButtonInner: styled.span`
    position: absolute;
    box-sizing: border-box;
    display: block;
    width: 18px;
    height: 18px;
    margin-left: 8px;
    transform: rotate(45deg);
    border: 3px solid #000;
    border-right: none;
    border-top: none;
  `,
};

const BackButton: React.FC<ButtonHTMLAttributes<HTMLButtonElement> & { isVisible: boolean }> = ({ ...props }) => (
  <s.Button {...props}>
    <s.ButtonInner />
  </s.Button>
);

export default BackButton;



// WEBPACK FOOTER //
// ./packages/smart-home-support/components/Header/components/BackButton.tsx